import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable to check permissions for the current account user.
 * Administrators always have permission.
 * @returns {{ hasPermission: (permission: string) => import('vue').ComputedRef<boolean> }}
 */
export function usePermissions() {
  const getters = useStoreGetters();

  const currentAccount = computed(() => {
    const { accounts = [] } = getters.getCurrentUser.value || {};
    return accounts.find(
      account => account.id === getters.getCurrentAccountId.value
    );
  });

  const currentRole = computed(() => currentAccount.value?.role);
  const permissions = computed(() => currentAccount.value?.permissions || []);

  const hasPermission = permission =>
    computed(
      () =>
        currentRole.value === 'administrator' ||
        permissions.value.includes(permission)
    );

  return {
    hasPermission,
  };
}
